export const temporaryFundDefaulftFormValues = {
  trustAccount: '',
  fromOrToContact: '',
  amount: '',
  recordCreateDate: '',
  description: '',
  paymentMethod: '',
  chequeNumber: '',
};

export const formValidationOptions = {
  trustAccount: {
    name: 'trustAccount',
    rules: { required: 'Account name is Required' },
  },
  fromOrToContact: {
    name: 'fromOrToContact',
    rules: { required: 'Contact name is Required' },
  },
  amount: {
    name: 'amount',
    rules: { required: 'Amount is Required' },
  },
  recordCreateDate: {
    name: 'recordCreateDate',
    rules: { required: 'Date is Required' },
  },
  description: {
    name: 'description',
  },
  paymentMethod: {
    name: 'paymentMethod',
    rules: { required: 'Payment Method is Required' },
  },
  chequeNumber: {
    name: 'chequeNumber',
    rules: {
      required: 'Check Number is Required',
      pattern: {
        value: /^[a-zA-Z0-9]+$/,
        message: 'Check number can only contain letters and numbers',
      },
    },
  },
};
